import React, { useState } from "react";

export default function Documentation() {
	const [height, setHeight] = useState("1000px")
	window.addEventListener("message", receiveMessage, false);

	function receiveMessage(event) {
		if (event.origin === "https://about.ch-aviation.com") {
			setHeight(event.data.toString() + "px");
		}
	}

	return (
		<div className="container tw-py-10">
			<iframe
				src="https://about.ch-aviation.com/data-dictionary/"
				title="Data Dictionary"
				width="100%"
				height={height}
				allow="fullscreen"
			></iframe>
		</div>
	);
}
